import React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path
            d="m284.216 64.545h-152.363v-44.737c0-6.797 5.51-12.307 12.307-12.307h127.749c6.797 0 12.307 5.51 12.307 12.307z"
            fill="#ee6161"
          />
        </g>
        <g>
          <path
            d="m284.216 19.806v44.743h-21.214v-44.743c0-6.791-5.509-12.3-12.31-12.3h21.214c6.801 0 12.31 5.509 12.31 12.3z"
            fill="#e94444"
          />
        </g>
        <g>
          <path
            d="m287.64 100.28h-159.21c-5.053 0-9.149-4.096-9.149-9.149v-17.436c0-5.053 4.096-9.149 9.149-9.149h159.21c5.053 0 9.149 4.096 9.149 9.149v17.436c0 5.053-4.096 9.149-9.149 9.149z"
            fill="#f79595"
          />
        </g>
        <g>
          <path
            d="m296.786 73.694v17.438c0 5.048-4.097 9.145-9.145 9.145h-23.088c5.048 0 9.145-4.097 9.145-9.145v-17.438c0-5.048-4.097-9.145-9.145-9.145h23.088c5.048 0 9.145 4.097 9.145 9.145z"
            fill="#f47c7c"
          />
        </g>
        <g>
          <path
            d="m262.617 504.498h-109.165c-7.957 0-14.407-6.45-14.407-14.407v-389.811h137.978v389.811c.001 7.957-6.449 14.407-14.406 14.407z"
            fill="#f9f3f1"
          />
        </g>
        <g>
          <path
            d="m277.024 100.277v389.813c0 7.953-6.45 14.403-14.403 14.403h-19.772c7.963 0 14.413-6.45 14.413-14.403v-389.813z"
            fill="#efe2dd"
          />
        </g>
        <g>
          <path d="m139.045 221.263h137.978v162.253h-137.978z" fill="#fec165" />
        </g>
        <g>
          <path d="m257.262 221.263h19.762v162.253h-19.762z" fill="#fdb441" />
        </g>
        <g>
          <path
            d="m373.967 504.498h-107.145c-10.356 0-18.752-8.395-18.752-18.752v-13.826c0-10.356 8.395-18.752 18.752-18.752h107.146c10.356 0 18.752 8.396 18.752 18.752v13.826c-.001 10.357-8.396 18.752-18.753 18.752z"
            fill="#fe9901"
          />
        </g>
        <g>
          <path
            d="m392.722 471.921v13.822c0 10.357-8.394 18.75-18.75 18.75h-20.914c10.357 0 18.75-8.393 18.75-18.75v-13.822c0-10.357-8.394-18.75-18.75-18.75h20.914c10.356-.001 18.75 8.393 18.75 18.75z"
            fill="#fb8801"
          />
        </g>
        <g>
          <path
            d="m373.967 401.839h-107.145c-10.356 0-18.752-8.395-18.752-18.752v-13.826c0-10.356 8.395-18.752 18.752-18.752h107.146c10.356 0 18.752 8.395 18.752 18.752v13.826c-.001 10.357-8.396 18.752-18.753 18.752z"
            fill="#fe9901"
          />
        </g>
        <g>
          <path
            d="m373.967 453.169h-107.145c-10.356 0-18.752-8.395-18.752-18.752v-13.826c0-10.356 8.395-18.752 18.752-18.752h107.146c10.356 0 18.752 8.395 18.752 18.752v13.826c-.001 10.356-8.396 18.752-18.753 18.752z"
            fill="#fec165"
          />
        </g>
        <g>
          <path
            d="m392.722 369.264v13.822c0 10.357-8.394 18.751-18.75 18.751h-20.914c10.357 0 18.75-8.394 18.75-18.751v-13.822c0-10.357-8.394-18.751-18.75-18.751h20.914c10.356 0 18.75 8.394 18.75 18.751z"
            fill="#fb8801"
          />
        </g>
        <g>
          <path
            d="m392.722 420.587v13.832c0 10.357-8.394 18.751-18.75 18.751h-20.914c10.357 0 18.75-8.394 18.75-18.751v-13.832c0-10.357-8.394-18.75-18.75-18.75h20.914c10.356 0 18.75 8.393 18.75 18.75z"
            fill="#fdb441"
          />
        </g>
        <g>
          <g>
            <path
              d="m229.43 293.03c-11.817 0-21.396-9.579-21.396-21.396 0-11.817 9.579-21.396 21.396-21.396 11.817 0 21.396 9.579 21.396 21.396 0 11.816-9.579 21.396-21.396 21.396z"
              fill="#ee6161"
            />
          </g>
          <g>
            <path
              d="m250.824 271.63c0 5.911-2.393 11.259-6.263 15.13-3.871 3.88-9.219 6.273-15.13 6.273-9.018 0-16.739-5.59-19.885-13.491 2.171.744 4.494 1.146 6.907 1.146 5.901 0 11.25-2.393 15.13-6.263 3.871-3.871 6.263-9.219 6.263-15.13 0-2.795-.533-5.469-1.518-7.912 3.137 1.056 5.941 2.825 8.234 5.117 3.869 3.881 6.262 9.229 6.262 15.13z"
              fill="#e94444"
            />
          </g>
          <g>
            <path d="m400.221 369.262c0-14.477-11.777-26.254-26.254-26.254h-18.975c-4.143 0-7.502 3.358-7.502 7.502s3.358 7.502 7.502 7.502h18.975c6.203 0 11.251 5.047 11.251 11.251v13.825c0 6.204-5.047 11.251-11.251 11.251h-107.145c-6.203 0-11.251-5.047-11.251-11.251v-13.825c0-6.204 5.047-11.251 11.251-11.251h53.573c4.143 0 7.502-3.358 7.502-7.502s-3.358-7.502-7.502-7.502h-35.87v-235.226h3.115c9.181 0 16.65-7.469 16.65-16.65v-17.437c0-7.773-5.361-14.3-12.573-16.125v-37.762c0-10.922-8.886-19.808-19.808-19.808h-73.324c-4.144 0-7.502 3.358-7.502 7.502s3.358 7.502 7.502 7.502h73.324c2.649 0 4.805 2.156 4.805 4.805v37.235h-137.359v-37.236c0-2.649 2.156-4.805 4.806-4.805h19.454c4.144 0 7.502-3.358 7.502-7.502s-3.359-7.501-7.503-7.501h-19.454c-10.922 0-19.809 8.886-19.809 19.808v37.762c-7.212 1.826-12.572 8.353-12.572 16.125v17.437c0 9.181 7.47 16.65 16.65 16.65h3.114v382.31c0 12.08 9.828 21.908 21.909 21.908h220.514c14.477 0 26.254-11.777 26.254-26.253v-13.827c0-7.34-3.032-13.983-7.904-18.751 4.873-4.769 7.904-11.412 7.904-18.752v-13.825c0-7.34-3.032-13.983-7.904-18.751 4.873-4.769 7.904-11.412 7.904-18.752v-13.827zm-130.699-26.254h-2.7c-14.477 0-26.254 11.777-26.254 26.254v6.752h-94.021v-147.249h122.975zm0-129.246h-122.975v-105.98h122.975zm-141.093-120.984c-.908 0-1.647-.738-1.647-1.647v-17.436c0-.908.738-1.648 1.647-1.648h159.211c.908 0 1.647.74 1.647 1.648v17.437c0 .908-.739 1.647-1.647 1.647h-159.211zm120.043 360.391c-4.873 4.769-7.904 11.411-7.904 18.751v13.826c0 4.024.913 7.838 2.538 11.25h-89.653c-3.807 0-6.906-3.097-6.906-6.905v-99.074h95.248c1.317 4.147 3.639 7.848 6.677 10.822-4.873 4.769-7.904 11.411-7.904 18.751v13.825c0 7.342 3.031 13.985 7.904 18.754zm136.746 32.578c0 6.203-5.047 11.25-11.251 11.25h-107.145c-6.203 0-11.251-5.047-11.251-11.25v-13.827c0-6.203 5.047-11.25 11.251-11.25h107.145c6.203 0 11.251 5.047 11.251 11.25zm0-51.33c0 6.204-5.047 11.251-11.251 11.251h-107.145c-6.203 0-11.251-5.047-11.251-11.251v-13.825c0-6.203 5.047-11.25 11.251-11.25h107.145c6.203 0 11.251 5.047 11.251 11.25z" />
            <path d="m229.43 300.531c15.934 0 28.897-12.963 28.897-28.897s-12.963-28.897-28.897-28.897-28.897 12.963-28.897 28.897 12.963 28.897 28.897 28.897zm0-42.791c7.661 0 13.894 6.233 13.894 13.894s-6.233 13.894-13.894 13.894-13.894-6.233-13.894-13.894 6.233-13.894 13.894-13.894z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
